import React from 'react'

const Save = () => {
  return (
    <div>Save</div>
  )
}

export default Save